import MaterialSymbolIcon from '@/components/global/MaterialSymbolIcon'

interface Props {
  className?: string
}

export default function SelectArrowDownIcon({ className }: Props) {
  return (
    <MaterialSymbolIcon
      className={className}
      name="keyboard_arrow_down"
      color="inherit"
    />
  )
}
